export default function WhyProgramsWork() {
  const reasons = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Перед тренингом анализируем переговорную практику: слушаем звонки, смотрим переписки, изучаем типовые сценарии.' },
    { icon: 'ri-file-settings-line', title: 'Адаптация', desc: 'Программа создаётся под конкретную компанию: отрасль, продукт, типы клиентов, частые ситуации.' },
    { icon: 'ri-presentation-line', title: 'Практика', desc: '80% времени — переговорные поединки, ролевые игры и разбор реальных кейсов. Минимум теории.' },
    { icon: 'ri-file-search-line', title: 'Реальные кейсы', desc: 'Разбираем переговоры, которые участники вели на прошлой неделе. Анализ, обратная связь, повтор.' },
    { icon: 'ri-road-map-line', title: 'Полевое сопровождение', desc: 'При необходимости участвую в реальных переговорах вместе с сотрудниками. Показываю на практике.' },
    { icon: 'ri-telegram-line', title: 'Telegram-поддержка', desc: 'После тренинга участники могут задать вопрос в чате в любой момент. Быстрая обратная связь.' },
    { icon: 'ri-chat-voice-line', title: 'Разбор переговоров', desc: 'Регулярный аудит проведённых встреч: что получилось, где потеряли, как улучшить.' },
    { icon: 'ri-refresh-line', title: 'Внедрение', desc: 'Помогаем внедрить новые подходы в ежедневную практику. Не просто обучили — изменили поведение.' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Измеримый результат', desc: 'Фиксируем KPI до и после: конверсия встреч, средний чек, процент скидок, маржинальность.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему наши программы <strong>обучения переговорам</strong> работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Девять принципов, которые отличают системный подход к <strong>корпоративному тренингу по переговорам</strong> от разовых мероприятий.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}